import DashboardIconLight from '@/assets/images/sidebar-icon/dashboard-icon-light.svg'
import DashboardIconDark from '@/assets/images/sidebar-icon/dashboard-icon-dark.svg'

import InsightsIconLight from '@/assets/images/sidebar-icon/insights-icon-light.svg'
import InsightsIconDark from '@/assets/images/sidebar-icon/insights-icon-dark.svg'

import AutomationIconLight from '@/assets/images/sidebar-icon/automation-icon-light.svg'
import AutomationIconDark from '@/assets/images/sidebar-icon/automation-icon-dark.svg'

import AdsManagerIconLight from '@/assets/images/sidebar-icon/ads-manager-icon-light.svg'
import AdsManagerIconDark from '@/assets/images/sidebar-icon/ads-manager-icon-dark.svg'

import CreativesIconLight from '@/assets/images/sidebar-icon/creatives-icon-light.svg'
import CreativesIconDark from '@/assets/images/sidebar-icon/creatives-icon-dark.svg'

import NewAdCampaignIconLight from '@/assets/images/sidebar-icon/new-ad-campaign-icon-light.svg'
import NewAdCampaignIconDark from '@/assets/images/sidebar-icon/new-ad-campaign-icon-dark.svg'

import MediaSettingsIconLight from '@/assets/images/sidebar-icon/media-settings-icon-light.svg'
import MediaSettingsIconDark from '@/assets/images/sidebar-icon/media-settings-icon-dark.svg'

export const logos = {
    Dashboard: {
        light: DashboardIconLight,
        dark: DashboardIconDark,
    },
    Insights: {
        light: InsightsIconLight,
        dark: InsightsIconDark,
    },
    Automation: {
        light: AutomationIconLight,
        dark: AutomationIconDark,
    },
    AddsManager: {
        light: AdsManagerIconLight,
        dark: AdsManagerIconDark,
    },
    Creatives: {
        light: CreativesIconLight,
        dark: CreativesIconDark,
    },
    NewAdCampaign: {
        light: NewAdCampaignIconLight,
        dark: NewAdCampaignIconDark,
    },
    MediaSettings: {
        light: MediaSettingsIconLight,
        dark: MediaSettingsIconDark,
    },
}
